export default state => {
  try {
    return state.receivablesEntries.loading || false;
  } catch (err) {
    return false;
  }
};
